import { SERVER } from "../config";

export default {
  server: SERVER,
};
